import { ENTITY_TYPES } from 'containers/App/modules/entities/entities.constants';
import { createNewEntitySlice } from 'containers/App/modules/entities/entities.utils';
import { parseFetchAllRequest } from './crcFailures.parsers';

const crcFailuresEntitySlice = createNewEntitySlice({
	name: ENTITY_TYPES.CRC_FAILURE_EVENTS || 'crcFailureEvents',
	parseFetchAllRequest
});

const { reducer, actions, selectors } = crcFailuresEntitySlice;

const {
	fetchAll:        fetchCrcFailures,
	fetchAllPending: fetchCrcFailuresPending,
	fetchAllSuccess: fetchCrcFailuresSuccess,
	fetchAllFailure: fetchCrcFailuresFailure,
} = actions;

export const crcFailuresEntityActions = {
	fetchCrcFailures,
	fetchCrcFailuresPending,
	fetchCrcFailuresSuccess,
	fetchCrcFailuresFailure,
};

const {
	selectAll:             selectCrcFailures,
	selectFetchAllPending: selectCrcFailuresPending,
} = selectors;

export const crcFailuresEntitySelectors = {
	selectCrcFailures,
	selectCrcFailuresPending,
};

export default reducer;


